import moment from 'moment';
import Swal from 'sweetalert2';
import authHelper from './helpers/authHelper';
import { axiosErrorHandler, axiosResponseHandler, callTheApServerGet } from './helpers/axiosHelper';
import { hydrateApBasicData } from './helpers/basicHelper';
import { addDNoneClass, btnLoading, byId } from './helpers/utility';




authHelper.validate();
hydrateApBasicData();
// checking query params for transition result alert










// get getAdminDepositLogs

let skip = 0;

const depositLogsTableLoadMoreDivElement = byId('depositLogsTableLoadMoreDivElement');


const getAdminDepositLogs = () => {
    addDNoneClass(depositLogsTableLoadMoreDivElement, true);

    callTheApServerGet(`/basic/getAdminDepositLogs/${skip}/10`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;




        const depositLogsTableBodyElement = byId('depositLogsTableBodyElement');
        const depositLogsTableNoDataRowElement = byId('depositLogsTableNoDataRowElement');

        if (res.status === 'success') {
            console.log(res);

            const adminDepositLogsData = res.adminDepositLogsData;
            let i = 0;
            skip += 10;




            if (adminDepositLogsData.length > 0) {
                addDNoneClass(depositLogsTableLoadMoreDivElement, false);
                addDNoneClass(depositLogsTableNoDataRowElement, true);


                while (i < adminDepositLogsData.length) {

                    const { createdAt, orderId, status, response } = adminDepositLogsData[i];

                    const date = moment(createdAt * 1000).format('DD/MM/YYYY');
                    const time = moment(createdAt * 1000).format('LT');

                  let   refreshBtnHtml = ``;
                    if (status === 'PENDING') {
                        refreshBtnHtml = `<button class="btn btn-success" onclick="refreshLogFunFun(this,${orderId})" >Refresh</button>`;
                    }

                    depositLogsTableBodyElement.innerHTML += `
                    <tr>
                       
                      
                    
                        <td>${orderId}</td>
                        
                        <td>${status}</td>
                        <td>${response}</td>
                    
                        <td>${date} <br> ${time}</td>
                        <td>${refreshBtnHtml}</td>
                    </tr>
                    `;
                    i++;
                 
                }
            }

            if (adminDepositLogsData.length === 0) {




                if (skip === 0) {
                    depositLogsTableNoDataRowElement.innerHTML = `
                    <th class='text-center' colspan='6'>No Wallet Transactions Found 😥</th> 
                    `;
                } else {
                    addDNoneClass(depositLogsTableLoadMoreDivElement, true);
                }
            } else {
                addDNoneClass(depositLogsTableLoadMoreDivElement, false);
            }



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

getAdminDepositLogs();




depositLogsTableLoadMoreDivElement.addEventListener('click', getAdminDepositLogs);

const refreshLogFunFun = async (btn ,orderId) =>{




   btnLoading(btn , '',true
   );

const parentTrElement = btn.parentNode.parentNode;

const statusTdElement = parentTrElement.children[1];
const responseTdElement = parentTrElement.children[2];

// console.log(parentTrElement);
// console.log(parentTrElement.children);



    callTheApServerGet(`/basic/refreshAdminDepositLog/${orderId}`).then((response) => {
        axiosResponseHandler(response);
        const res = response.data;





        if (res.status === 'success') {
            addDNoneClass(btn,true);
            console.log(res);
            statusTdElement.innerHTML= res.transactionStatus;
            responseTdElement.innerHTML= res.transactionResponse;

            if(res.transactionStatus ==='PENDING'){
                Swal.fire({
                    icon: 'info',
                    title: 'Transaction is Under Process',
                    text: 'Try to refresh after 10 minutes',
        
                });
               
            }

          




          



        }
    }).catch((error) => {
        axiosErrorHandler(error);
        console.log(error);
    });
};

window.refreshLogFunFun=refreshLogFunFun;
